<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <!-- <form-data v-else-if="!this.$route.params.project_id" :references.sync="formReferences" :model="projectObj" ref="projectReference"></form-data> -->
    <v-card flat>
      <v-list-item-content>
        <v-list-item-title><strong>Name:</strong> {{projectObj.name}}</v-list-item-title>
        <v-list-item-title><strong>Responsible:</strong> {{ setResponsibleName(projectObj.responsibleid) }}</v-list-item-title>
    </v-list-item-content>
    </v-card>
    <v-row class="pa-2">
      <template v-if="this.$route.params.project_id">
        <v-tabs v-model="tab" background-color="primary" grow dark>
          <v-tab>{{ $t('message.layout.activities') }}</v-tab>
          <v-tab>{{ $t('message.layout.members') }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" style="width:100%;">
          <v-tab-item>
            <activity :projectId="this.$route.params.project_id"></activity>
          </v-tab-item>
          <v-tab-item>
            <member :projectId="this.$route.params.project_id"></member>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-row>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import FormTemplate from '@/components/FormTemplate'
import CONSTANTS from '@/assets/json/constants.json'
import Activity from '@/views/Activity/Activity'
import Member from '@/views/Member/Member'

export default {
  data () {
    return {
      projectObj: {
        id: this.$route.params.project_id
      },
      fieldsLoading: false,
      loading: false,
      MODULE_URL: 'projects',
      tab: 0
    }
  },
  components: {
    /* 'form-data': FormTemplate, */
    Activity,
    Member
  },
  computed: {
    ...mapGetters(['formType', 'getUsers']),
    formReferences () {
      return {
        title: this.$t(`message.common.${this.projectObj.id ? 'updateProject' : 'addProject'}`),
        properties: [{
          model: 'name',
          type: this.formType.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.common.name'),
          class: 'lg4 sm6'
        }, {
          model: 'responsibleid',
          type: this.formType.AUTO_COMPLETE,
          items: this.getUsers,
          rules: this.$_requiredValidation,
          select_text: 'name',
          select_value: 'so_userid',
          class: 'lg4 sm4 xs12',
          label: this.$t('message.common.responsible')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.project_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(CONSTANTS.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'close_handler',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveUpdateHandler(CONSTANTS.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.project_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push(`/${this.MODULE_URL}`),
          label: this.$t('message.common.backToList'),
          to: `/${this.MODULE_URL}`,
          is_show: true
        }]
      }
    }
  },
  mounted () {
    if (this.projectObj.id) this.getSingleRecordHandler()
  },
  methods: {
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$api.getSingleRecordHandler(`${this.MODULE_URL}/${this.projectObj.id}`)
        .then((result) => {
          if (result.data) this.projectObj = result.data
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type) {
      if (this.$refs.projectReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.$format.cloneVariable(this.projectObj)
        this.$api.saveUpdateHandler(this.MODULE_URL, model)
          .then((response) => {
            response.snackbar.text = this.$t(response.snackbar.text)
            this.$root.$emit('snackbar', response.snackbar)
            if (type === CONSTANTS.SAVE && !model.id) this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
            else if (type === CONSTANTS.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    setResponsibleName (id) {
      let obj = this.getUsers.find(x => x.so_userid === id)
      return obj ? obj.name : ''
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
